import CustomerSettings from './CustomerSettings';

export default CustomerSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/CustomerSettings/index.tsx